var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkdin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_365)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4_365)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_4_365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7841 1.00146H2.17124C1.52601 1.00146 0.994629 1.5708 0.994629 2.25399V16.7908C0.994629 17.474 1.52601 18.0054 2.17124 18.0054H16.7841C17.4292 18.0054 17.9985 17.474 17.9985 16.7908V2.25399C17.9985 1.5708 17.4292 1.00146 16.7841 1.00146ZM6.11859 15.5763H3.61354V7.49181H6.11859V15.5763ZM4.86607 6.35315C4.03105 6.35315 3.38581 5.70792 3.38581 4.91085C3.38581 4.11379 4.03105 3.4306 4.86607 3.4306C5.66313 3.4306 6.30836 4.11379 6.30836 4.91085C6.30836 5.70792 5.66313 6.35315 4.86607 6.35315ZM15.5695 15.5763H13.0264V11.629C13.0264 10.718 13.0264 9.50344 11.736 9.50344C10.4075 9.50344 10.2178 10.5282 10.2178 11.591V15.5763H7.71271V7.49181H10.1039V8.59252H10.1418C10.4834 7.94728 11.3184 7.26408 12.533 7.26408C15.0761 7.26408 15.5695 8.97207 15.5695 11.1356V15.5763Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_365"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.0532227)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4_365"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.0532227)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_4_365"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.0532227)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkdin);
export default __webpack_public_path__ + "static/media/linkdin.e81b1747092d503bd72686b8d3283212.svg";
export { ForwardRef as ReactComponent };